import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Car, Hotel, Lightbulb, ChevronRight, TowerControl } from "lucide-react";
import api from "../lib/api";

/* Article merging: enriches TravelerPulse airport pages for Indian airports with
   the IndianAirports.com guide content TP doesn't already show (transport, hotels,
   tips) — no duplicate overview text (TP has its own AI profile). */
export const IndiaAirportGuide = ({ iata }) => {
  const [a, setA] = useState(null);

  useEffect(() => {
    if (!iata) return;
    api.get(`/india/airports/${iata}`).then((r) => setA(r.data)).catch(() => setA(null));
  }, [iata]);

  const e = a?.enrichment || {};
  if (!a || (!e.groundTransport?.length && !e.travelTips?.length && !e.nearbyHotels?.length)) return null;

  return (
    <div className="border border-orange-200 bg-gradient-to-br from-orange-50/60 to-white p-5" data-testid="tp-india-guide">
      <div className="flex flex-wrap items-center gap-2">
        <TowerControl className="w-5 h-5 text-orange-600" />
        <h2 className="font-heading font-900 text-orange-700 text-xl sm:text-2xl">India Airport Guide</h2>
        <Link to={`/india/airports/${a.slug}`} data-testid="tp-india-guide-link"
          className="ml-auto inline-flex items-center gap-1 text-xs font-700 text-blue-700 hover:underline">
          Full {a.iata} portal on IndianAirports.com <ChevronRight className="w-3.5 h-3.5" />
        </Link>
      </div>
      {e.groundTransport?.length > 0 && (
        <div className="mt-4">
          <div className="text-xs font-800 uppercase tracking-wide text-zinc-500 flex items-center gap-1.5"><Car className="w-3.5 h-3.5" /> Getting there{e.distanceToCity ? ` · ${e.distanceToCity} to city` : ""}</div>
          <div className="mt-2 space-y-1.5">
            {e.groundTransport.slice(0, 4).map((g) => (
              <div key={g.mode} className="flex flex-wrap items-center gap-2 bg-white border border-zinc-200 rounded-lg px-3 py-2 text-sm">
                <span className="font-700 w-20 shrink-0">{g.mode}</span>
                <span className="text-zinc-600 flex-1 min-w-[160px] text-xs sm:text-sm">{g.detail}</span>
                {g.fare && !/^(n\/a|varies)$/i.test(g.fare.trim()) && <span className="text-[11px] font-700 text-emerald-700">{g.fare}</span>}
              </div>
            ))}
          </div>
        </div>
      )}
      {e.nearbyHotels?.length > 0 && (
        <div className="mt-4">
          <div className="text-xs font-800 uppercase tracking-wide text-zinc-500 flex items-center gap-1.5"><Hotel className="w-3.5 h-3.5" /> Hotels near {a.iata}</div>
          <div className="mt-2 flex flex-wrap gap-1.5">
            {e.nearbyHotels.slice(0, 5).map((h) => (
              <span key={h.name} className="text-xs font-600 bg-white border border-zinc-200 rounded-full px-2.5 py-1">{h.name}{h.distanceKm != null ? ` · ${h.distanceKm} km` : ""}</span>
            ))}
          </div>
        </div>
      )}
      {e.travelTips?.length > 0 && (
        <div className="mt-4">
          <div className="text-xs font-800 uppercase tracking-wide text-zinc-500 flex items-center gap-1.5"><Lightbulb className="w-3.5 h-3.5" /> Traveler tips</div>
          <ul className="mt-2 space-y-1">
            {e.travelTips.slice(0, 3).map((t, i) => <li key={i} className="text-sm text-zinc-700 flex items-start gap-2"><span className="text-amber-500 mt-0.5">•</span> {t}</li>)}
          </ul>
        </div>
      )}
      <p className="mt-3 text-[11px] text-zinc-400">Last verified {a.last_verified} · IndianAirports.com, powered by TravelerPulse.</p>
    </div>
  );
};
